@use '@lib/assets/styles/main.scss' as *;

.root {
  border-radius: 50%;
  outline: none;

  &:disabled {
    .loaderHolder {
      color: $gray900;
    }
  }
}

/* Button types */
.primary-outlined {
  color: $gray700;
  background-color: transparent;
  border: 1px solid $gray200;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      background-color: $blue20;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $blue50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $gray0;
      border-color: $disable300;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $blue200;
  }
}

.primary-filled {
  color: $gray0;
  background-color: $blue500;
  border: 1px solid $blue500;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      background-color: $blue400;
      border-color: $blue400;
      box-shadow: 0 1px 3px 1px rgba($gray1000, 0.15), 0 1px 3px 1px rgba($gray1000, 0.15);
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $blue400;
      border-color: $blue400;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $disable300;
      border-color: $disable300;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $blue200;
  }

  .counter {
    background-color: $error900;
  }
}

.secondary-outlined {
  color: $gray700;
  background-color: $gray0;
  border: 1px solid $blue20;
  box-shadow: 0 2px 6px 0 rgba(33, 78, 235, 0.15);

  &:not(:disabled) {
    &:hover {
      background-color: $gray10;
      border-color: $blue50;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $blue50;
      border-color: $blue50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $gray0;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $blue200;
  }
}

.secondary-filled {
  color: $gray700;
  background-color: transparent;
  border: 1px solid transparent;

  &:not(:disabled) {
    &:hover {
      background-color: $blue20;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $blue50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: transparent;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $blue200;
  }
}

.secondary-invert {
  color: $gray700;
  background-color: $gray0;
  border: 1px solid transparent;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      background-color: $blue20;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $blue50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $disable300;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $blue50;
  }
}

.tertiary-filled {
  color: $gray400;
  background-color: transparent;
  border: 1px solid transparent;

  &:not(:disabled) {
    &:hover {
      background-color: $gray10;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $gray50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: transparent;
      color: $disable300;
    }
  }

  span[class*='ripple'] {
    background-color: $blue200;
  }
}

.tertiary-invert {
  color: $gray0;
  background-color: rgba($gray900, 0.4);
  border: 1px solid rgba($gray900, 0.4);
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      background-color: rgba($gray900, 0.5);
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $gray500;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: transparent;
      color: $disable500;
      border-color: transparent;
    }
  }

  span[class*='ripple'] {
    background-color: $blue50;
  }
}

.quaternary-outlined {
  color: $gray400;
  background-color: transparent;
  border: 1px solid $gray500;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      color: $gray200;
      background-color: $gray700;
      border-color: $gray500;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $gray500;
      border-color: $gray500;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $gray0;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $gray400;
  }
}

.quaternary-filled {
  color: $gray400;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      background-color: $gray10;
      border-color: $gray10;
    }

    &.focused,
    &:focus,
    &:active {
      background-color: $gray50;
      border-color: $gray50;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: transparent;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $gray400;
  }
}

.negative-outlined {
  color: $error900;
  background-color: $gray0;
  border: 1px solid $gray200;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      border-color: $error100;
    }

    &.focused,
    &:focus,
    &:active {
      border-color: $error900;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $gray0;
      border-color: $disable300;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $error100;
  }

  .counter {
    background-color: $warning900;
  }
}

.negative-filled {
  color: $gray0;
  background-color: $error900;
  border: 1px solid $error900;
  border-radius: 6px;

  &:not(:disabled) {
    &:hover {
      border-color: $error100;
    }

    &.focused,
    &:focus,
    &:active {
      border-color: $error900;
    }
  }

  &:not(.loading) {
    &:disabled {
      background-color: $gray0;
      border-color: $disable300;
      color: $disable500;
    }
  }

  span[class*='ripple'] {
    background-color: $error100;
  }

  .counter {
    background-color: $warning900;
  }
}

/* Button sizes */
.small {
  width: 32px;
  height: 32px;
}

.medium {
  width: 40px;
  height: 40px;
}

/* Button other styles */
.rounded {
  border-radius: 50%;
}
